import { render } from "./FlexBox.vue?vue&type=template&id=58f80ae5&scoped=true"
import script from "./FlexBox.vue?vue&type=script&lang=js"
export * from "./FlexBox.vue?vue&type=script&lang=js"

import "./FlexBox.vue?vue&type=style&index=0&id=58f80ae5&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f80ae5"]])

export default __exports__